import styled from 'styled-components';

export const SurveyFormContainer = styled.div`
  width: clamp(50%, 700px, 90%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 50px;
  margin-right: 50px;
  align-items: center;

  p {
    margin-bottom: 5px;
    margin-top: 0px;
    text-align: left;
    font-size: 15px;
    font-weight: bold;
  }

  h6 {
    text-align: left;
    margin-bottom: 5px;
  }
  #comments_text_box {
    height: 200px;
    width: clamp(50%, 700px, 90%);
    margin-top: 30px;

    &.shrink {
      font-size: 25px;
    }
  }
  @media screen and (max-width: 800px) {
    padding-rigt: 20px;
    margin-bottom: 50px;
  }
  #nums + label {
    color: black;
  }

  #dof + label {
    top: -20px;
    font-size: 15px;
    font-weight: bold;
    color: black;
  }

  .search-wrapper {
    background-color: white;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const SurveyTitle = styled.h2`
  margin: 10px 0;
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    font-size: 15px;
    margin: 20px;
    line-height: 50px;
    font-family: apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
  }

  label {
    font-size: 20px;
  }
  @media screen and (max-width: 800px) {
    width: 95%;
  }
`;

export const VizContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  button {
    font-size: 15px;
    margin: 20px;
    line-height: 50px;
    font-family: apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
  }
`;
